module.exports = __webpack_public_path__ + "img/success.b15bb416.png";